import type { ValidHref } from '../types';

export const isValidHref = (href: string): href is ValidHref => {
  // Later, we might leverage Next's typed routes functionality to make this safer
  // https://nextjs.org/docs/app/building-your-application/configuring/typescript#statically-typed-links
  if (href?.startsWith('/')) return true;
  return false;
};
